// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".placeholder__cursor[data-v-2ccf6718]{animation:cursorBlink-2ccf6718 .8s infinite;background-color:#fff;color:#3b54ab;display:inline-block;height:18px;margin-left:-2px;width:2px}.placeholder__cursor--typing[data-v-2ccf6718]{animation:none}.placeholder__typed-text[data-v-2ccf6718]{color:#3b54ab;font-weight:700}@keyframes cursorBlink-2ccf6718{49%{background-color:#3b54ab}50%{background-color:transparent}99%{background-color:transparent}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
